import {
  put,
  select,
  call,
  cancelled,
  takeEvery,
} from 'redux-saga/effects';
import Auth from '../../../auth/auth';
import * as config from '../../../lib/config';
import { PRORATE_RESULTS_START, PRORATE_RESULTS_FAILURE } from "../types";
import { prorateResultsSuccess, prorateResultsFailure } from "../actions";
import { updatePrintData, getLocalPrintData, generatePrintableWindow } from '../results/generatePrintableWindow';
import LZString from 'lz-string';
import { toast } from 'react-toastify';

const getProrationInputs = (state) => ({
  calculationId: state.calculationResults.calculationId,
});

function mergeProratedResults(momentSignature, newCalcResults) {
  let currentPrintData = getLocalPrintData();
  currentPrintData[momentSignature].
    calculationResults.proratedTable = {
    costByYearTable: newCalcResults.charts.costByYearTable,
    chartYears: newCalcResults.charts.chartYears,
  };
  let serializedPrintData = LZString.compress(JSON.stringify(currentPrintData));
  updatePrintData(serializedPrintData, momentSignature);
  generatePrintableWindow(momentSignature);
}

export function* handleProrationStart(action) {
  try {
    const { momentSignature } = action.payload;
    const { calculationId } = yield select(getProrationInputs);
    if (!calculationId) {
      throw new Error('Cannot request proration without a valid calculationId.');
    }

    new Auth().checkAuth();

    const endpoint = `${config.baseURL()}/api/calculations/prorate/${calculationId}`;

    const response = yield call(fetch, endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({})
    });

    const results = yield response.json();
    mergeProratedResults(momentSignature, results);

    if (!response.ok) {
      throw new Error(results.message || 'Proration failed on the server.');
    }

    yield put(prorateResultsSuccess(results));

  } catch (error) {
    yield put(prorateResultsFailure(error.message));
  } finally {
    if (yield cancelled()) {
      yield put(prorateResultsFailure('Cancelled'));
    }
  }
}

export function* handleProrateFailure() {
  toast('Error Generating Prorated Reports. Please Refresh Your Browser and Try Running the Report Again.',
    {
      type: 'error',
      toastId: 'prorate-error',
    }
  );
}

export function* watchProrationSaga() {
  yield takeEvery(PRORATE_RESULTS_START, handleProrationStart);
  yield takeEvery(PRORATE_RESULTS_FAILURE, handleProrateFailure);
}
